import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  IconButton,
  Checkbox,
  Box,
  Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { formatDate } from '../utils/helpers';

export default function NoteCard({ note, onEdit, onDelete, onToggle }) {
  return (
    <Card elevation={1} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flex: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box sx={{ mr: 1 }}>
            <Typography variant="h6" sx={{ textDecoration: note.completed ? 'line-through' : 'none' }}>
              {note.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              {note.body || <span style={{ color: '#9e9e9e' }}>(no content)</span>}
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'right' }}>
            <Tooltip title={note.completed ? 'Completed' : 'Mark as completed'}>
              <Checkbox checked={note.completed} onChange={() => onToggle(note.id)} />
            </Tooltip>
          </Box>
        </Box>
      </CardContent>

      <CardActions sx={{ justifyContent: 'space-between', px: 2 }}>
        <Typography variant="caption" color="text.secondary">
          {formatDate(note.createdAt)}
        </Typography>

        <Box>
          <IconButton size="small" onClick={() => onEdit(note)}>
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => onDelete(note.id)}>
            <DeleteIcon fontSize="small" color="error" />
          </IconButton>
        </Box>
      </CardActions>
    </Card>
  );
}
